import { useEffect, useRef } from "react";
import * as d3 from "d3";
import * as Cases from '../slices/casesSlice';
import { useAppSelector } from "../slices";

export interface Datum {
	value: number;
}

const DrawDonutChart = (element: any, data: Datum[], size: number) => {
	const colors = ["#98C000", "#201F22"];

	d3.select(element).select("svg").remove();
	const svg = d3
		.select(element)
		.append("svg")
		.attr("preserveAspectRatio", "xMidYMid meet")
		.attr("height", size)
		.attr("width", size)
		.attr("viewBox", `0 0 ${size} ${size}`)
		.append("g")
		.attr("transform", `translate(${size / 2}, ${size / 2})`);

	svg.append("circle")
		.attr("r", 0)
		.attr("fill", "#201F22")
		.attr("stroke-width", 0)
		.attr("r", (size / 2));

	size *= 0.75;

	const arcGenerator = d3.arc<Datum>().innerRadius(size / 3).outerRadius(size / 2).padRadius((2 / size) - 5).padAngle(2 / size).cornerRadius(4);
	const pieGenerator = d3.pie<Datum>().value((d) => d.value).sort(null)(data);

	const arcs = svg.selectAll().data(pieGenerator).enter();
	arcs
		.append("path")
		.attr("d", arcGenerator)
		.style("fill", (d: any, i: number) => colors[i % data.length])
		.transition().duration(500)
		.attrTween("d", (d) => {
			var i = d3.interpolate(d.startAngle + 0.1, d.endAngle);
			return function (t) {
				d.endAngle = i(t);
				return arcGenerator(d) as string;
			}
		});
};

export const ChartData = (item: Cases.caseListState | null): Array<Datum> => {
	const user = useAppSelector(state => state.user);
	const cases = useAppSelector(state => state.cases);
	const trackerChartOptions = cases.trackerChartOptions[item!.type as keyof Cases.TrackerChartOptions];

	if (item && item.tracker) {
		let ff = 0;
		let uf = 0;

		for (let [key, value] of Object.entries(item.tracker)) {
			for (let subValue of Object.entries(trackerChartOptions)) {
				if (subValue[1].items) {
					for (const trackerChartColumn of subValue[1].items) {
						if (trackerChartColumn.message === value.message && trackerChartColumn.isVisible) {
							if (value.value && value.isVisible && (user.introducer.panelReferDescription === "Real Estate" ? value.stage === "Secured Lending" : true)) {
								ff += value.weight;
								continue;
							}
							uf += value.weight;
						}
					}
				}
			}
		}
		return [{ value: ff }, { value: uf }] as Array<Datum>;
	}
	return [{ value: 0 }, { value: 0 }] as Array<Datum>;
}

const DonutChart = (props: { data: Datum[], size: number }) => {
	const ref = useRef(null);

	useEffect(() => {
		if (ref.current) {
			let size = props.size;
			if ((ref.current as HTMLDivElement).clientWidth < props.size) {
				size = (ref.current as HTMLDivElement).clientWidth;
			}
			DrawDonutChart(ref.current, props.data, size);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ref]);

	return (
		<div className="DonutChart" ref={ref} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} />
	);
}

export default DonutChart;